import React, { Fragment } from 'react';
import {
  List,
  Datagrid,
  TextField,
  DatagridBody,
  DateField,
} from 'react-admin';
import Filter from './Filter';
import Empty from '../../components/react-admin/Empty';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const PhoneField = (props) => {
  if (props.record) {
    return (
      <div
        style={{
          justifyContent: 'left',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <div
          style={{
            minWidth: 30,
            minHeight: 30,
            borderRadius: 15,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontWeight: 'bold',
            fontSize: 15,
          }}
        >
          {props.record['user']['tel']
            ? props.record['user']['tel']
            : props.record['order']['tel']}
        </div>
      </div>
    );
  }
  return <span></span>;
};

const MyDatagridRow = ({
  record,
  resource,
  id,
  onToggleItem,
  children,
  selected,
  selectable,
  basePath,
}) => (
  <TableRow key={id}>
    {React.Children.map(children, (field) => (
      <TableCell key={`${id}-${field.props.source}`}>
        {React.cloneElement(field, {
          record,
          basePath,
          resource,
        })}
      </TableCell>
    ))}
  </TableRow>
);

const MyDatagridBody = (props) => {
  return (
    <Fragment>
      <DatagridBody {...props} row={<MyDatagridRow />} />
    </Fragment>
  );
};
const MyDatagrid = (props) => {
  return (
    <Fragment>
      <MyHeader></MyHeader>
      <Datagrid {...props} body={<MyDatagridBody />} />
    </Fragment>
  );
};

const MyHeader = () => {
  const rowStyle = {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 15,
    marginRight: 15,
  };

  const titleStyle = {
    marginRight: 3,
    fontWeight: 'bold',
  };
  const valStyle = {
    fontWeight: 'bold',
  };

  return (
    <div
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        height: 80,
      }}
    >
      <div
        style={{
          padding: 15,
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <div style={rowStyle}>
          <div style={titleStyle}>Дундаж үнэлгээ:</div>
          <div style={{ ...valStyle }}>
            {localStorage.getItem('x-average-rating')
              ? localStorage.getItem('x-average-rating')
              : '-'}
          </div>
        </div>

        <div style={rowStyle}>
          <div style={titleStyle}>Үнэлгээ өгсөн тоо:</div>
          <div style={{ ...valStyle }}>
            {localStorage.getItem('x-total-count')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default (props) => {
  return (
    <List
      perPage={25}
      title={'Үнэлгээ'}
      filters={<Filter />}
      empty={<Empty emptyMessage={'Үр дүн байхгүй байна.'} />}
      {...props}
      sort={{ field: 'createdAt', order: 'DESC' }}
      bulkActionButtons={false}
    >
      <MyDatagrid>
        <DateField
          label="Огноо"
          source="createdAt"
          showTime
          options={{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
          }}
        />
        <TextField
          label="Улсын дугаар"
          source="taxi.vehicleNumber"
          sortable={false}
        />
        <TextField label="Жолооч" source="taxi.driver.name" sortable={false} />
        <TextField label="Үнэлгээ" source="rating" sortable={false} />
        <TextField label="Сэтгэгдэл" source="note" sortable={false} />
        <PhoneField label="Хэрэглэгч" sortable={false} />
      </MyDatagrid>
    </List>
  );
};
